export default __webpack_public_path__ + "static/media/Sage's Bracers of the Soaring God.dd4191ac.jpg";